module.exports = __webpack_public_path__ + "img/popup_battery_2.90ad30e6.svg";